import { useState, useMemo } from "react"
import NoData from "components/commons/NoData"
import UserCard2 from "./UserCard2"
import { useTranslation } from "react-i18next"

export default function UsersCatalog({ users }) {

     const [t] = useTranslation(["global"])
    const [search, setSearch] = useState("")

    const filtered = useMemo(() => {
        if (!search.trim()) return users
        const q = search.trim().toLowerCase()
        return users.filter(u => u.displayName?.toLowerCase().includes(q))
    }, [users, search])

    const useGrouping = filtered.length > 15

    const groups = useMemo(() => {
        if (!useGrouping) return null
        return filtered.reduce((acc, user) => {
            const letter = (user.displayName?.[0] ?? "#").toUpperCase()
            if (!acc[letter]) acc[letter] = []
            acc[letter].push(user)
            return acc
        }, {})
    }, [filtered, useGrouping])

    return (
        <div>
            <div className="mb-3 col-6">
                <input
                    type="text"
                    className="form-control"
                    placeholder={t("helper.search")}
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </div>

            {filtered.length === 0 && <NoData />}

            {useGrouping
                ? Object.keys(groups).sort().map(letter => (
                    <div key={letter} className="mb-4">
                        <div className="row">
                            <div className="row align-items-center">
                                <h6 className="fw-bold mb-3 col-auto">{letter}</h6>
                                <hr className="col" />
                            </div>
                        </div>
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2">
                            {groups[letter].map(user => (
                                <div className="col" key={user.guid}>
                                    <UserCard2 user={user} />
                                </div>
                            ))}
                        </div>
                    </div>
                ))
                : (
                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2">
                        {filtered.map(user => (
                            <div className="col" key={user.guid}>
                                <UserCard2 user={user} />
                            </div>
                        ))}
                    </div>
                )
            }
        </div>
    )
}
